import $ from 'jquery'

$(document).on('turbolinks:load', function () {
  const paramTagIds = window.location.search.split(/tag_ids=([\d,]+)&?/)[1]

  if (paramTagIds) {
    paramTagIds.split(',').forEach((id) => {
      const $element = $('[data-market-tag-id~=' + id + ']').data(
        'active',
        false
      )
      selectMarketTag($element, false)
    })
  }
})

$(document).on(
  'click',
  "[data-behavior~='market-filter-tag-item']",
  function () {
    selectMarketTag(this, true)
  }
)

const selectMarketTag = function (tagElement, pushState) {
  const $item = $(tagElement)
  const alreadyActive = Boolean($item.data('active'))

  $("[data-behavior~='market-package']").removeClass('hidden')

  $item.toggleClass('sf-c-primary sf-bg-primary-subtle', !alreadyActive)
  $item.attr('data-active', !alreadyActive).data('active', !alreadyActive)
  $item
    .find("[data-behavior~='market-filter-tag-deselect']")
    .toggleClass('hidden', alreadyActive)

  const selectedTags = []
  const selectedTagIds = []
  $("[data-behavior~='market-filter-tag-item'][data-active='true']").each(
    function () {
      selectedTags.push(
        '[data-market-tag-' + $(this).data('market-tag-id') + ']'
      )
      selectedTagIds.push($(this).data('market-tag-id'))
    }
  )
  if (selectedTags.length > 0) {
    $("[data-behavior~='market-package']")
      .not(selectedTags.join(''))
      .addClass('hidden')
  }

  if (pushState) {
    const urlState = '?tag_ids=' + selectedTagIds.join(',') + ''
    window.history.pushState({ turbolinks: true }, '', urlState)
  }
}

$(document).on('click', "[data-behavior~='market-tag-label']", function () {
  window.location.href =
    '' +
    $("[data-behavior~='market-package-info']").data('market-url') +
    '?tag_ids=' +
    $(this).data('market-tag-label-id') +
    ''
})

/* global BigPicture */
$(document).on(
  'click',
  "[data-behavior~='market-package-images'] img",
  function (e) {
    BigPicture({
      el: e.target,
      gallery: "[data-behavior~='market-package-images']",
    })
  }
)
